// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7f9a01b9","703":"800972e5"}[chunkId] + ".chunk.js";
};